const AnchorListBlock = (() => {
    const initBlock = (el) => {
        const select = el.querySelector("select");
        
        function handleSelectChange() {
            if (select) {
                const selectedOption = select.options[select.selectedIndex];
                const url = selectedOption.value;
                if (url) {
                    window.location.href = url;
                }
            }
        }
        
        if (select) {
            select.addEventListener("change", handleSelectChange);
        }
    };

    return { initBlock };
})();

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-anchor-list-block]").forEach(item => AnchorListBlock.initBlock(item));
});
